import React from 'react'
import EnrolButton from '../EnrolButton/EnrolButton'
import Icons from '../Icons/Icons'
import './Footer.css'

const Footer = () => {
  return (
    <footer className='footer'>
      <div className='footer-content'>
        <div className='footer-columns'>
          <div className='footer-column footer-contact'>
            <h3 className='footer-title'>Get in Touch</h3>
            <p className='footer-text'>Find us on Social Media or Email us for any enquiries.</p>
            <div className='footer-icons'>
              <Icons instagram facebook email />
            </div>
          </div>

          <div className='footer-column footer-cta'>
            <h3 className='footer-title'>Ready to Join Us?</h3>
            <p className='footer-text'>Start your dance journey with CC Choreography today!</p>
            <EnrolButton />
          </div>

          <div className='footer-column'>
            <h3 className='footer-title'>Our Studios</h3>
            <p className='footer-text'>
              CC Choreography, Hamilton North — Unit 23/54 Clyde St
              <br />
              Tiny Tutus, Lambton — 27 Wyong Rd
            </p>
          </div>
        </div>

        <div className='footer-copyright'>
          <div className='copyright'>&copy; {new Date().getFullYear()} CC Choreography. <span>WEBSITE BY LAURA ASHLEIGH</span></div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
